export default __webpack_public_path__ + "static/media/gallery-05_full.fb3730d2.jpg";